import { render, staticRenderFns } from "./TheWhy.vue?vue&type=template&id=89573c54"
import script from "./TheWhy.vue?vue&type=script&lang=js"
export * from "./TheWhy.vue?vue&type=script&lang=js"
import style0 from "./TheWhy.vue?vue&type=style&index=0&id=89573c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports